import React, { useEffect } from 'react';
import HeaderStyleTwo from '../Shared/HeaderStyleTwo';
import Footer from '../Shared/Footer';
import ScrollToTop from '../Shared/ScrollToTop';
import axios from 'axios';
import MaskedInput from 'react-text-mask';
import NumberFormat from 'react-number-format';
import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import InputAdornment from '@material-ui/core/InputAdornment';
import PaymentIcon from '@material-ui/icons/Payment';
import Select from '@material-ui/core/Select';
import { MenuItem, withStyles } from '@material-ui/core';
import SecurityIcon from '@material-ui/icons/Security';
import Alert from '@material-ui/lab/Alert/Alert';
import MoneyIcon from '@material-ui/icons/Money';
import AlternateEmailIcon from '@material-ui/icons/AlternateEmail';
import emailMask from 'text-mask-addons/dist/emailMask';
import ToggleButton from '@material-ui/lab/ToggleButton';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { signInAnonymously } from '../../Services/user/user.api';
import { FETCH_STATUSES } from '../../Services/base/types';
import { AppState } from '../../Services';
import Cryptr from 'cryptr';
import { v4 as uuidv4 } from 'uuid';
import { CountryRegionData } from 'react-country-region-selector';
const cryptr = new Cryptr(
  'AIzaSyAN7RRyq6XFpzuIwLolmRjG2GHT4HpPxcE-1:394913796951:web:6e1734d36d7324d593e412'
);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        margin: theme.spacing(1),
      },
    },
    textField: {
      marginTop: theme.spacing(2),
      minWidth: 120,
    },
    formControl: {
      marginTop: theme.spacing(2),
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
  })
);

const StyledToggleButton = withStyles({
  root: {
    fontFamily: 'Arial',
    fontSize: '14px',
    textAlign: 'left',
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: 'rgba(0, 0, 0, 0.87)',
    padding: '15px 15px',
    textTransform: 'none',
    display: 'block',
    width: '100%',
    '&$selected': {
      backgroundColor: '#ff6d12',
      color: '#FFFFFF',
      '&:hover': {
        backgroundColor: '#ff6d12',
        color: '#FFFFFF',
      },
    },
  },
  selected: {},
})(ToggleButton);

interface TextMaskCustomProps {
  inputRef: (ref: HTMLInputElement | null) => void;
}

function validateEmail(email: string) {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

function TextMaskCustom(props: TextMaskCustomProps) {
  const { inputRef, ...other } = props;
  return (
    <MaskedInput
      {...other}
      ref={(ref: any) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={emailMask}
      placeholderChar={'\u2000'}
      showMask
    />
  );
}

interface NumberFormatCustomProps {
  //@ts-ignore
  inputRef: (instance: NumberFormat | null) => void;
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
}

function CardNumberFormatCustom(props: NumberFormatCustomProps) {
  const { inputRef, onChange, ...other } = props;
  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      isNumericString
      format='#### #### #### ####'
      mask='_'
    />
  );
}

function SecurityCodeFormatCustom(props: NumberFormatCustomProps) {
  const { inputRef, onChange, ...other } = props;
  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      isNumericString
      format='####'
    />
  );
}

function DonationFormatCustom(props: NumberFormatCustomProps) {
  const { inputRef, onChange, ...other } = props;
  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
      prefix='$'
    />
  );
}

function SharesFormatCustom(props: NumberFormatCustomProps) {
  const { inputRef, onChange, ...other } = props;
  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
    />
  );
}

const ValidationTextField = withStyles({
  root: {
    '& input:valid + fieldset': {
      borderColor: 'green',
      borderWidth: 2,
    },
    '& input:invalid + fieldset': {
      borderColor: 'red',
      borderWidth: 2,
    },
    '& input:valid:focus + fieldset': {
      borderLeftWidth: 6,
      padding: '4px !important',
    },
  },
})(TextField);

interface State {
  quantityOfShares: string;
  qurbaniLocation: string;
  cardNumber: string;
  securityCode: string;
  donation: string;
  firstName: string;
  lastName: string;
  country: string;
  region: string;
  address: string;
  address2: string;
  city: string;
  postalCode: string;
  email: string;
  type: string;
  donationType: string;
  programType: string;
  expirationMonth: string;
  expirationYear: string;
  isProcessingFeeAdded: boolean;
  makeDonationAnonymous: boolean;
  uid: string;
  comment: string;
}
const DonateToQurbaniUdhiyaSadaqahObligations = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const payload: any = location.state;
  const CHARACTER_LIMIT_DONATION = 8;

  const [qurbaniCustom, setQurbaniCustom] = React.useState(false);
  const [qurbaniShare1, setQurbaniShare1] = React.useState(false);
  const [qurbaniShare2, setQurbaniShare2] = React.useState(false);
  const [qurbaniShare3, setQurbaniShare3] = React.useState(false);
  const [qurbaniShare4, setQurbaniShare4] = React.useState(false);
  const [qurbaniShare5, setQurbaniShare5] = React.useState(false);
  const [qurbaniShare6, setQurbaniShare6] = React.useState(false);
  const [qurbaniShare7, setQurbaniShare7] = React.useState(false);
  const [qurbaniShare8, setQurbaniShare8] = React.useState(false);
  const [qurbaniShare9, setQurbaniShare9] = React.useState(false);
  const [qurbaniShare10, setQurbaniShare10] = React.useState(false);

  const [qurbaniCustomValue, setQurbaniCustomValue] = React.useState('');
  const [qurbaniShare1Value, setQurbaniShare1Value] = React.useState('');
  const [qurbaniShare2Value, setQurbaniShare2Value] = React.useState('');
  const [qurbaniShare3Value, setQurbaniShare3Value] = React.useState('');
  const [qurbaniShare4Value, setQurbaniShare4Value] = React.useState('');
  const [qurbaniShare5Value, setQurbaniShare5Value] = React.useState('');
  const [qurbaniShare6Value, setQurbaniShare6Value] = React.useState('');
  const [qurbaniShare7Value, setQurbaniShare7Value] = React.useState('');
  const [qurbaniShare8Value, setQurbaniShare8Value] = React.useState('');
  const [qurbaniShare9Value, setQurbaniShare9Value] = React.useState('');
  const [qurbaniShare10Value, setQurbaniShare10Value] = React.useState('');

  const [invoiceAmount, setInvoiceAmount] = React.useState('');
  const [paymentProcessingFee, setpaymentProcessingFee] = React.useState('');
  const [donationAmount, setDonationAmount] = React.useState('');
  const [values, setValues] = React.useState<State>({
    qurbaniLocation: 'Pakistan',
    quantityOfShares: '',
    cardNumber: '',
    securityCode: '',
    donation: '',
    firstName: '',
    lastName: '',
    country: 'United States',
    region: '',
    address: '',
    address2: '',
    city: '',
    postalCode: '',
    email: '',
    type: 'once',
    donationType: '',
    programType: 'sadaqah-udhiya-qurbani-obligation',
    expirationMonth: '',
    expirationYear: '',
    makeDonationAnonymous: false,
    isProcessingFeeAdded: true,
    uid: '',
    comment: '',
  });

  const costPerQurbaniShare = 110;

  useEffect(() => {
    runJQueryScripts();
    window.scrollTo(0, 0);
    if ((values.quantityOfShares as string) === '1') {
      setQurbaniShare1(true);
      setQurbaniShare2(true);
      const totalCost =
        Number(values.quantityOfShares as string) * costPerQurbaniShare;
      calcFee(totalCost);
    }
  }, []);
  const runJQueryScripts = () => {
    let tag: any;
    let loadScript = function (src: string) {
      tag = document.createElement('script');
      tag.async = false;
      tag.src = src;
      document.getElementsByTagName('body')[0].appendChild(tag);
    };
    loadScript('../assets/js/jquery.js');
    loadScript('../assets/js/popper.min.js');
    loadScript('../assets/js/jquery-ui.js');
    loadScript('../assets/js/jquery.fancybox.js');
    loadScript('../assets/js/owl.js');
    loadScript('../assets/js/appear.js');
    loadScript('../assets/js/wow.js');
    loadScript('../assets/js/lazyload.js');
    loadScript('../assets/js/scrollbar.js');
    loadScript('../assets/js/script.js');
    return () => {
      document.getElementsByTagName('body')[0].removeChild(tag);
    };
  };
  const [isShowSharesError, setIsShowSharesError] = React.useState(false);
  const [isShowDonationError, setIsShowDonationError] = React.useState(false);
  const [isShowCardNumberError, setIsShowCardNumberError] =
    React.useState(false);
  const CHARACTER_LIMIT_CARD_NUMBER = 27;
  const [isShowSecurityCodeError, setIsShowSecurityCodeError] =
    React.useState(false);
  const [btnDisabled, setBtnDisabled] = React.useState(false);
  const [isShowFirstNameError, setIsShowFirstNameError] = React.useState(false);
  const CHARACTER_LIMIT_FIRST_NAME = 25;
  const [isShowLastNameError, setIsShowLastNameError] = React.useState(false);
  const CHARACTER_LIMIT_LAST_NAME = 25;
  const [isShowEmailError, setIsShowEmailError] = React.useState(false);
  const CHARACTER_LIMIT_EMAIL_NAME = 50;
  const CHARACTER_LIMIT_QUANTITYOFSHARES = 1;
  const CHARACTER_LIMIT_COMMENT = 150;
  const CHARACTER_LIMIT_ZIP = 5;
  const [isShowTypeError, setIsShowTypeError] = React.useState(false);
  const [isShowPostalCodeError, setIsShowPostalCodeError] =
    React.useState(false);
  const [isShowCityError, setIsShowCityError] = React.useState(false);
  const [isShowAddressError, setIsShowAddressError] = React.useState(false);

  const [qurbaniCustomValueError, setQurbaniCustomValueError] =
    React.useState(false);
  const [qurbaniShare1ValueError, setQurbaniShare1ValueError] =
    React.useState(false);
  const [qurbaniShare2ValueError, setQurbaniShare2ValueError] =
    React.useState(false);
  const [qurbaniShare3ValueError, setQurbaniShare3ValueError] =
    React.useState(false);
  const [qurbaniShare4ValueError, setQurbaniShare4ValueError] =
    React.useState(false);
  const [qurbaniShare5ValueError, setQurbaniShare5ValueError] =
    React.useState(false);
  const [qurbaniShare6ValueError, setQurbaniShare6ValueError] =
    React.useState(false);
  const [qurbaniShare7ValueError, setQurbaniShare7ValueError] =
    React.useState(false);
  const [qurbaniShare8ValueError, setQurbaniShare8ValueError] =
    React.useState(false);
  const [qurbaniShare9ValueError, setQurbaniShare9ValueError] =
    React.useState(false);
  const [qurbaniShare10ValueError, setQurbaniShare10ValueError] =
    React.useState(false);

  const [fullBigAnimal, setFullBigAnimal] = React.useState(false);
  const [otherDonation, setOtherDonation] = React.useState(false);
  const [copyToAll, setCopyToAll] = React.useState(false);
  const [country, setCountry] = React.useState([
    'United States',
    'US',
    'Alabama~AL|Alaska~AK|American Samoa~AS|Arizona~AZ|Arkansas~AR|California~CA|Colorado~CO|Connecticut~CT|Delaware~DE|District of Columbia~DC|Micronesia~FM|Florida~FL|Georgia~GA|Guam~GU|Hawaii~HI|Idaho~ID|Illinois~IL|Indiana~IN|Iowa~IA|Kansas~KS|Kentucky~KY|Louisiana~LA|Maine~ME|Marshall Islands~MH|Maryland~MD|Massachusetts~MA|Michigan~MI|Minnesota~MN|Mississippi~MS|Missouri~MO|Montana~MT|Nebraska~NE|Nevada~NV|New Hampshire~NH|New Jersey~NJ|New Mexico~NM|New York~NY|North Carolina~NC|North Dakota~ND|Northern Mariana Islands~MP|Ohio~OH|Oklahoma~OK|Oregon~OR|Palau~PW|Pennsylvania~PA|Puerto Rico~PR|Rhode Island~RI|South Carolina~SC|South Dakota~SD|Tennessee~TN|Texas~TX|Utah~UT|Vermont~VT|Virgin Islands~VI|Virginia~VA|Washington~WA|West Virginia~WV|Wisconsin~WI|Wyoming~WY|Armed Forces Americas~AA|Armed Forces Europe, Canada, Africa and Middle East~AE|Armed Forces Pacific~AP',
  ]);
  const [region, setRegion] = React.useState(['']);
  const [isShowRegionError, setIsShowRegionError] = React.useState(false);
  const [isShowCountryError, setIsShowCountryError] = React.useState(false);
  const [isShowQuantityOfSharesError, setIsShowQuantityOfSharesError] =
    React.useState(false);
  const [isShowExpirationMonthError, setIsShowExpirationMonthError] =
    React.useState(false);

  const [isShowProgramTypeError, setIsShowProgramTypeError] =
    React.useState(false);
  const [isShowExpirationYearError, setIsShowExpirationYearError] =
    React.useState(false);
  const [isDonationFocus, setIsDonationFocus] = React.useState(false);
  let textInputDonation = React.createRef();

  const signInStatus = useSelector(
    (state: AppState) => state.user.status || null
  );
  // eslint-disable-next-line no-restricted-globals
  const isDirty = signInStatus === FETCH_STATUSES.LOADING;
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValues({
      ...values,
      [event.target.name]: event.target.checked,
    });
  };

  const handleIsProcessingFeeAddedChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    console.log('handleIsProcessingFeeAddedChange--->', event.target.checked);
    console.log('fullBigAnimal--->', fullBigAnimal);

    setValues({
      ...values,
      [event.target.name]: event.target.checked,
    });

    let totalCost = 0;
    if (event.target.checked === false) {
      console.log('event.target.checked--->', event.target.checked);
      console.log('values.quantityOfShares--->', values.quantityOfShares);

      if (values.quantityOfShares !== '') {
        if (values.quantityOfShares === '1') {
          totalCost = Number(values.quantityOfShares) * costPerQurbaniShare;
        }
        if (values.quantityOfShares === '2') {
          totalCost = Number(values.quantityOfShares) * costPerQurbaniShare;
        }
        if (values.quantityOfShares === '3') {
          totalCost = Number(values.quantityOfShares) * costPerQurbaniShare;
        }
        if (values.quantityOfShares === '4') {
          totalCost = Number(values.quantityOfShares) * costPerQurbaniShare;
        }
        if (values.quantityOfShares === '5') {
          totalCost = Number(values.quantityOfShares) * costPerQurbaniShare;
        }
        if (values.quantityOfShares === '6') {
          totalCost = Number(values.quantityOfShares) * costPerQurbaniShare;
        }
        if (values.quantityOfShares === '7') {
          totalCost = Number(values.quantityOfShares) * costPerQurbaniShare;
        }
        if (values.quantityOfShares === 'Other') {
          totalCost = Number(values.donation);
        }
      } else if (fullBigAnimal === true) {
        totalCost = 7 * costPerQurbaniShare;
      }

      setInvoiceAmount(totalCost + '');
    } else {
      console.log('values.quantityOfShares else--->', values.quantityOfShares);
      if (values.quantityOfShares !== '') {
        if (values.quantityOfShares === '1') {
          totalCost = Number(values.quantityOfShares) * costPerQurbaniShare;
          calcFee(totalCost);
        }
        if (values.quantityOfShares === '2') {
          totalCost = Number(values.quantityOfShares) * costPerQurbaniShare;
          calcFee(totalCost);
        }
        if (values.quantityOfShares === '3') {
          totalCost = Number(values.quantityOfShares) * costPerQurbaniShare;
          calcFee(totalCost);
        }
        if (values.quantityOfShares === '4') {
          totalCost = Number(values.quantityOfShares) * costPerQurbaniShare;
          calcFee(totalCost);
        }
        if (values.quantityOfShares === '5') {
          totalCost = Number(values.quantityOfShares) * costPerQurbaniShare;
          calcFee(totalCost);
        }
        if (values.quantityOfShares === '6') {
          totalCost = Number(values.quantityOfShares) * costPerQurbaniShare;
          calcFee(totalCost);
        }
        if (values.quantityOfShares === '7') {
          totalCost = Number(values.quantityOfShares) * costPerQurbaniShare;
          calcFee(totalCost);
        }
        if (values.quantityOfShares === 'Other') {
          totalCost = Number(values.donation);
          calcFee(totalCost);
        }
      } else if (fullBigAnimal === true) {
        totalCost = 7 * costPerQurbaniShare;
        calcFee(totalCost);
      }
    }
  };

  const handleFullBigAnimalChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setOtherDonation(false);
    setFullBigAnimal(event.target.checked);

    let totalCost = 0;
    if (event.target.checked === false) {
      setQurbaniShare1(false);
      setQurbaniShare2(false);
      setQurbaniShare3(false);
      setQurbaniShare4(false);
      setQurbaniShare5(false);
      setQurbaniShare6(false);
      setQurbaniShare7(false);
      setQurbaniCustom(false);
      if (values.quantityOfShares !== '') {
        if (values.quantityOfShares === '1') {
          totalCost = Number(values.quantityOfShares) * costPerQurbaniShare;
        }
        if (values.quantityOfShares === '2') {
          totalCost = Number(values.quantityOfShares) * costPerQurbaniShare;
        }
        if (values.quantityOfShares === '3') {
          totalCost = Number(values.quantityOfShares) * costPerQurbaniShare;
        }
        if (values.quantityOfShares === '4') {
          totalCost = Number(values.quantityOfShares) * costPerQurbaniShare;
        }
        if (values.quantityOfShares === '5') {
          totalCost = Number(values.quantityOfShares) * costPerQurbaniShare;
        }
        if (values.quantityOfShares === '6') {
          totalCost = Number(values.quantityOfShares) * costPerQurbaniShare;
        }
      }

      setInvoiceAmount(totalCost + '');
      setValues({
        ...values,
        ['quantityOfShares']: '',
      });
    } else if (event.target.checked === true) {
      setValues({
        ...values,
        ['quantityOfShares']: '',
      });
      setIsShowQuantityOfSharesError(false);
      setQurbaniShare1(true);
      setQurbaniShare2(true);
      setQurbaniShare3(true);
      setQurbaniShare4(true);
      setQurbaniShare5(true);
      setQurbaniShare6(true);
      setQurbaniShare7(true);
      setQurbaniCustom(false);
      totalCost = 7 * costPerQurbaniShare;
      calcFee(totalCost);
    }
  };

  const handleOtherDonationChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setValues({
      ...values,
      ['quantityOfShares']: '',
    });

    setIsShowQuantityOfSharesError(false);
    setOtherDonation(event.target.checked);
    setFullBigAnimal(false);
    let totalCost = 0;
    if (event.target.checked === false) {
      if (values.quantityOfShares !== '') {
        if (values.quantityOfShares === '1') {
          totalCost = Number(values.quantityOfShares) * costPerQurbaniShare;
        }
        if (values.quantityOfShares === '2') {
          totalCost = Number(values.quantityOfShares) * costPerQurbaniShare;
        }
        if (values.quantityOfShares === '3') {
          totalCost = Number(values.quantityOfShares) * costPerQurbaniShare;
        }
        if (values.quantityOfShares === '7') {
          totalCost = Number(values.quantityOfShares) * costPerQurbaniShare;
        }
        if (values.quantityOfShares === 'Other') {
          totalCost = Number(values.donation);
        }
      }

      setInvoiceAmount(totalCost + '');
    } else {
      setQurbaniCustom(true);
      setQurbaniShare1(false);
      setQurbaniShare2(false);
      setQurbaniShare3(false);
      setQurbaniShare4(false);
      setQurbaniShare5(false);
      setQurbaniShare6(false);
      setQurbaniShare7(false);
      if (values.quantityOfShares === '1') {
        totalCost = Number(values.quantityOfShares) * costPerQurbaniShare;
        calcFee(totalCost);
      }
      if (values.quantityOfShares === '2') {
        totalCost = Number(values.quantityOfShares) * costPerQurbaniShare;
        calcFee(totalCost);
      }
      if (values.quantityOfShares === '3') {
        totalCost = Number(values.quantityOfShares) * costPerQurbaniShare;
        calcFee(totalCost);
      }
      if (values.quantityOfShares === '7') {
        totalCost = Number(values.quantityOfShares) * costPerQurbaniShare;
        calcFee(totalCost);
      }
      if (values.quantityOfShares === 'Other') {
        totalCost = Number(values.donation);
        calcFee(totalCost);
      }
    }
  };
  const handleCopyToAllChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setCopyToAll(event.target.checked);
    if (qurbaniShare1Value !== undefined && qurbaniShare1Value !== '') {
      setQurbaniCustomValueError(false);
      setQurbaniShare1ValueError(false);
      setQurbaniShare2ValueError(false);
      setQurbaniShare3ValueError(false);
      setQurbaniShare4ValueError(false);
      setQurbaniShare5ValueError(false);
      setQurbaniShare6ValueError(false);
      setQurbaniShare7ValueError(false);
    }

    if (event.target.checked === false) {
      setQurbaniShare2Value('');
      setQurbaniShare3Value('');
      setQurbaniShare4Value('');
      setQurbaniShare5Value('');
      setQurbaniShare6Value('');
      setQurbaniShare7Value('');
    } else if (event.target.checked === true) {
      if (
        qurbaniShare1Value !== undefined &&
        qurbaniShare1Value !== null &&
        qurbaniShare1Value !== ''
      ) {
        setQurbaniShare2Value(qurbaniShare1Value);
        setQurbaniShare3Value(qurbaniShare1Value);
        setQurbaniShare4Value(qurbaniShare1Value);
        setQurbaniShare5Value(qurbaniShare1Value);
        setQurbaniShare6Value(qurbaniShare1Value);
        setQurbaniShare7Value(qurbaniShare1Value);
      }
    }
  };
  const calcFee = (amount: number) => {
    let total = (amount + parseFloat('0.3')) / (1 - parseFloat('2.9') / 100);
    let fee = total - amount;
    setInvoiceAmount(total.toFixed(2));
    setpaymentProcessingFee(fee.toFixed(2));
    setDonationAmount(amount.toFixed(2));
  };

  const handleChangeCardNumber = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setIsShowCardNumberError(false);
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  const handleChangeSecurityCode = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setIsShowSecurityCodeError(false);
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  const handleChangeDonation = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsShowDonationError(false);

    calcFee(Number(event.target.value));

    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  const handleChangeQurbaniCustomValue = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setQurbaniCustomValue(event.target.value);
    setQurbaniCustomValueError(false);
  };

  const handleChangeQurbaniShare1Value = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setQurbaniShare1Value(event.target.value);
    setQurbaniShare1ValueError(false);
  };

  const handleChangeQurbaniShare2Value = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setQurbaniShare2Value(event.target.value);
    setQurbaniShare2ValueError(false);
  };

  const handleChangeQurbaniShare3Value = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setQurbaniShare3Value(event.target.value);
    setQurbaniShare3ValueError(false);
  };

  const handleChangeQurbaniShare4Value = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setQurbaniShare4Value(event.target.value);
    setQurbaniShare4ValueError(false);
  };

  const handleChangeQurbaniShare5Value = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setQurbaniShare5Value(event.target.value);
    setQurbaniShare5ValueError(false);
  };

  const handleChangeQurbaniShare6Value = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setQurbaniShare6Value(event.target.value);
    setQurbaniShare6ValueError(false);
  };

  const handleChangeQurbaniShare7Value = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setQurbaniShare7Value(event.target.value);
    setQurbaniShare7ValueError(false);
  };

  const handleChangeQurbaniShare8Value = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setQurbaniShare8Value(event.target.value);
    setQurbaniShare8ValueError(false);
  };

  const handleChangeQurbaniShare9Value = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setQurbaniShare9Value(event.target.value);
    setQurbaniShare9ValueError(false);
  };

  const handleChangeQurbaniShare10Value = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setQurbaniShare10Value(event.target.value);
    setQurbaniShare10ValueError(false);
  };

  const handleChangeFirstName = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setShowMessageSuccess(false);
    setIsShowFirstNameError(false);

    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  const handleChangeLastName = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsShowLastNameError(false);
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  const getRegions = () => {
    let countryRegionData = [''];
    CountryRegionData.forEach(element => {
      if (element[0] === values?.country) {
        countryRegionData = element;
      }
    });

    return countryRegionData[2].split('|').map(regionPair => {
      let [regionName, regionShortCode = null] = regionPair.split('~');
      return regionName;
    });
  };

  const handleChangeAddress = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsShowAddressError(false);
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  const handleChangeCity = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsShowCityError(false);
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  const handleChangePostalCode = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setIsShowPostalCodeError(false);
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  const handleChangeAddress2 = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  const handleChangeComment = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  const handleChangeEmail = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsShowEmailError(false);
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  const handleQuantityOfSharesChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setIsShowQuantityOfSharesError(false);
    let totalCost = 0;
    if ((event.target.value as string) === '1') {
      totalCost = Number(event.target.value as string) * costPerQurbaniShare;
      calcFee(totalCost);
      setQurbaniShare1(true);
      setQurbaniShare2(false);
      setQurbaniShare3(false);
      setQurbaniShare4(false);
      setQurbaniShare5(false);
      setQurbaniShare6(false);
      setQurbaniShare7(false);
      setQurbaniShare8(false);
      setQurbaniShare9(false);
      setQurbaniShare10(false);
      setQurbaniCustom(false);
      setFullBigAnimal(false);
      setOtherDonation(false);

      setValues({
        ...values,
        [event.target.name]: event.target.value,
      });
    } else if ((event.target.value as string) === '2') {
      totalCost = Number(event.target.value as string) * costPerQurbaniShare;
      calcFee(totalCost);
      setQurbaniShare1(true);
      setQurbaniShare2(true);
      setQurbaniShare3(false);
      setQurbaniShare4(false);
      setQurbaniShare5(false);
      setQurbaniShare6(false);
      setQurbaniShare7(false);
      setQurbaniShare8(false);
      setQurbaniShare9(false);
      setQurbaniShare10(false);
      setQurbaniCustom(false);
      setFullBigAnimal(false);
      setOtherDonation(false);

      setValues({
        ...values,
        [event.target.name]: event.target.value,
      });
    } else if ((event.target.value as string) === '3') {
      totalCost = Number(event.target.value as string) * costPerQurbaniShare;
      calcFee(totalCost);
      setQurbaniShare1(true);
      setQurbaniShare2(true);
      setQurbaniShare3(true);
      setQurbaniShare4(false);
      setQurbaniShare5(false);
      setQurbaniShare6(false);
      setQurbaniShare7(false);
      setQurbaniShare8(false);
      setQurbaniShare9(false);
      setQurbaniShare10(false);
      setQurbaniCustom(false);
      setFullBigAnimal(false);
      setOtherDonation(false);

      setValues({
        ...values,
        [event.target.name]: event.target.value,
      });
    } else if ((event.target.value as string) === '4') {
      totalCost = Number(event.target.value as string) * costPerQurbaniShare;
      calcFee(totalCost);
      setQurbaniShare1(true);
      setQurbaniShare2(true);
      setQurbaniShare3(true);
      setQurbaniShare4(true);
      setQurbaniShare5(false);
      setQurbaniShare6(false);
      setQurbaniShare7(false);
      setQurbaniShare8(false);
      setQurbaniShare9(false);
      setQurbaniShare10(false);
      setQurbaniCustom(false);
      setFullBigAnimal(false);
      setOtherDonation(false);

      setValues({
        ...values,
        [event.target.name]: event.target.value,
      });
    } else if ((event.target.value as string) === '5') {
      totalCost = Number(event.target.value as string) * costPerQurbaniShare;
      calcFee(totalCost);
      setQurbaniShare1(true);
      setQurbaniShare2(true);
      setQurbaniShare3(true);
      setQurbaniShare4(true);
      setQurbaniShare5(true);
      setQurbaniShare6(false);
      setQurbaniShare7(false);
      setQurbaniShare8(false);
      setQurbaniShare9(false);
      setQurbaniShare10(false);
      setQurbaniCustom(false);
      setFullBigAnimal(false);
      setOtherDonation(false);

      setValues({
        ...values,
        [event.target.name]: event.target.value,
      });
    } else if ((event.target.value as string) === '6') {
      totalCost = Number(event.target.value as string) * costPerQurbaniShare;
      calcFee(totalCost);
      setQurbaniShare1(true);
      setQurbaniShare2(true);
      setQurbaniShare3(true);
      setQurbaniShare4(true);
      setQurbaniShare5(true);
      setQurbaniShare6(true);
      setQurbaniShare7(false);
      setQurbaniShare8(false);
      setQurbaniShare9(false);
      setQurbaniShare10(false);
      setQurbaniCustom(false);
      setFullBigAnimal(false);
      setOtherDonation(false);

      setValues({
        ...values,
        [event.target.name]: event.target.value,
      });
    } else if ((event.target.value as string) === '7') {
      setQurbaniShare1(true);
      setQurbaniShare2(true);
      setQurbaniShare3(true);
      setQurbaniShare4(true);
      setQurbaniShare5(true);
      setQurbaniShare6(true);
      setQurbaniShare7(true);
      setQurbaniCustom(false);
      setValues({
        ...values,
        [event.target.name]: '',
      });
      setFullBigAnimal(true);
      setOtherDonation(false);
    } else if ((event.target.value as string) === '8') {
      setQurbaniShare1(true);
      setQurbaniShare2(true);
      setQurbaniShare3(true);
      setQurbaniShare4(true);
      setQurbaniShare5(true);
      setQurbaniShare6(true);
      setQurbaniShare7(true);
      setQurbaniCustom(false);
      setValues({
        ...values,
        [event.target.name]: '',
      });
      setFullBigAnimal(true);
      setOtherDonation(false);
    } else if ((event.target.value as string) === '9') {
      setQurbaniShare1(true);
      setQurbaniShare2(true);
      setQurbaniShare3(true);
      setQurbaniShare4(true);
      setQurbaniShare5(true);
      setQurbaniShare6(true);
      setQurbaniShare7(true);
      setQurbaniCustom(false);
      setValues({
        ...values,
        [event.target.name]: '',
      });
      setFullBigAnimal(true);
      setOtherDonation(false);
    }
  };

  const handleChangeType = (
    event: React.MouseEvent<HTMLElement>,
    type: string
  ) => {
    setIsShowTypeError(false);
    setValues({
      ...values,
      ['type']: type,
    });
  };

  const handleSelectedQurbaniSharesChange = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    let totalCost = 0;
    if ((event.target.value as string) === '1') {
      totalCost = Number(event.target.value as string) * costPerQurbaniShare;
      calcFee(totalCost);
      setQurbaniShare1(true);
      setQurbaniShare2(false);
      setQurbaniShare3(false);
      setQurbaniShare4(false);
      setQurbaniShare5(false);
      setQurbaniShare6(false);
      setQurbaniShare7(false);
      setQurbaniShare8(false);
      setQurbaniShare9(false);
      setQurbaniShare10(false);
    } else if ((event.target.value as string) === '2') {
      totalCost = Number(event.target.value as string) * costPerQurbaniShare;
      calcFee(totalCost);
      setQurbaniShare1(true);
      setQurbaniShare2(true);
      setQurbaniShare3(false);
      setQurbaniShare4(false);
      setQurbaniShare5(false);
      setQurbaniShare6(false);
      setQurbaniShare7(false);
      setQurbaniShare8(false);
      setQurbaniShare9(false);
      setQurbaniShare10(false);
    } else if ((event.target.value as string) === '3') {
      totalCost = Number(event.target.value as string) * costPerQurbaniShare;
      calcFee(totalCost);
      setQurbaniShare1(true);
      setQurbaniShare2(true);
      setQurbaniShare3(true);
      setQurbaniShare4(false);
      setQurbaniShare5(false);
      setQurbaniShare6(false);
      setQurbaniShare7(false);
      setQurbaniShare8(false);
      setQurbaniShare9(false);
      setQurbaniShare10(false);
    } else if ((event.target.value as string) === '7') {
      totalCost = Number(event.target.value as string) * costPerQurbaniShare;
      calcFee(totalCost);
      setQurbaniShare1(true);
      setQurbaniShare2(true);
      setQurbaniShare3(true);
      setQurbaniShare4(true);
      setQurbaniShare5(true);
      setQurbaniShare6(true);
      setQurbaniShare7(true);
      setQurbaniShare8(false);
      setQurbaniShare9(false);
      setQurbaniShare10(false);
    }

    setValues({
      ...values,
      ['quantityOfShares']: event.target.value as string,
    });
  };
  const handleSelectedQurbaniSharesChange1 = (
    event: React.MouseEvent<HTMLElement>,
    quantityOfShares: string
  ) => {
    let totalCost = 0;
    if ((quantityOfShares as string) === '1') {
      totalCost = Number(quantityOfShares) * costPerQurbaniShare;
      calcFee(totalCost);
      setQurbaniShare1(true);
      setQurbaniShare2(false);
      setQurbaniShare3(false);
      setQurbaniShare4(false);
      setQurbaniShare5(false);
      setQurbaniShare6(false);
      setQurbaniShare7(false);
      setQurbaniShare8(false);
      setQurbaniShare9(false);
      setQurbaniShare10(false);
    } else if ((quantityOfShares as string) === '2') {
      totalCost = Number(quantityOfShares) * costPerQurbaniShare;
      calcFee(totalCost);
      setQurbaniShare1(true);
      setQurbaniShare2(true);
      setQurbaniShare3(false);
      setQurbaniShare4(false);
      setQurbaniShare5(false);
      setQurbaniShare6(false);
      setQurbaniShare7(false);
      setQurbaniShare8(false);
      setQurbaniShare9(false);
      setQurbaniShare10(false);
    } else if ((quantityOfShares as string) === '3') {
      totalCost = Number(quantityOfShares) * costPerQurbaniShare;
      calcFee(totalCost);
      setQurbaniShare1(true);
      setQurbaniShare2(true);
      setQurbaniShare3(true);
      setQurbaniShare4(false);
      setQurbaniShare5(false);
      setQurbaniShare6(false);
      setQurbaniShare7(false);
      setQurbaniShare8(false);
      setQurbaniShare9(false);
      setQurbaniShare10(false);
    } else if ((quantityOfShares as string) === '7') {
      totalCost = Number(quantityOfShares) * costPerQurbaniShare;
      calcFee(totalCost);
      setQurbaniShare1(true);
      setQurbaniShare2(true);
      setQurbaniShare3(true);
      setQurbaniShare4(true);
      setQurbaniShare5(true);
      setQurbaniShare6(true);
      setQurbaniShare7(true);
      setQurbaniShare8(false);
      setQurbaniShare9(false);
      setQurbaniShare10(false);
    } else if ((quantityOfShares as string) === 'Other') {
      setQurbaniCustom(true);
      setQurbaniShare1(false);
      setQurbaniShare2(false);
      setQurbaniShare3(false);
      setQurbaniShare4(false);
      setQurbaniShare5(false);
      setQurbaniShare6(false);
      setQurbaniShare7(false);
      setQurbaniShare8(false);
      setQurbaniShare9(false);
      setQurbaniShare10(false);
    }

    setValues({
      ...values,
      ['quantityOfShares']: quantityOfShares as string,
    });
  };

  const handleChangeExpirationMonth = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    setIsShowExpirationMonthError(false);
    setValues({
      ...values,
      ['expirationMonth']: event.target.value as string,
    });
  };

  const handleChangeCountry = (val: any) => {
    setIsShowCountryError(false);
    setValues({
      ...values,
      ['country']: val.target.value as string,
    });
  };
  const handleChangeRegion = (val: any) => {
    setIsShowRegionError(false);
    setValues({
      ...values,
      ['region']: val.target.value as string,
    });
  };

  const handleChangeExpirationYear = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    setIsShowExpirationYearError(false);
    setValues({
      ...values,
      ['expirationYear']: event.target.value as string,
    });
  };
  const [showLoader, setShowLoader] = React.useState(false);
  const [showMessageSuccess, setShowMessageSuccess] = React.useState(false);
  const [showMessageError, setShowMessageError] = React.useState(false);
  const [messageSuccess, setMessageSuccess] = React.useState('');
  const [messageError, setMessageError] = React.useState('');
  const donateNow = async () => {
    try {
      let totalCost = 0;

      if (values.quantityOfShares !== '') {
        if (values.quantityOfShares === '1') {
          totalCost = Number(values.quantityOfShares) * costPerQurbaniShare;
          calcFee(totalCost);
        }
        if (values.quantityOfShares === '2') {
          totalCost = Number(values.quantityOfShares) * costPerQurbaniShare;
          calcFee(totalCost);
        }
        if (values.quantityOfShares === '3') {
          totalCost = Number(values.quantityOfShares) * costPerQurbaniShare;
          calcFee(totalCost);
        }
        if (values.quantityOfShares === '7') {
          totalCost = Number(values.quantityOfShares) * costPerQurbaniShare;
          calcFee(totalCost);
        }
        if (values.quantityOfShares === 'Other') {
          totalCost = Number(values.donation) * costPerQurbaniShare;
          calcFee(totalCost);
        }
      }

      const signInData = await signInAnonymously(
        values.firstName,
        values.lastName,
        values.email && values.email !== undefined
          ? values.email
          : 'dev.mahop@gmail.com'
      );

      if (signInData && signInData.uid !== undefined && signInData.uid !== '') {
        setValues({
          ...values,
          ['uid']: signInData.uid,
        });
        const today = new Date();
        const todaydd = String(today.getDate()).padStart(2, '0');
        const todaymm = String(today.getMonth() + 1).padStart(2, '0');
        const todayyyyy = today.getFullYear();
        const lastFour = values.cardNumber.substr(values.cardNumber.length - 4);
        let uuid = uuidv4();
        let id = uuid + '-' + lastFour;
        const data = {
          quantityOfShares: values.quantityOfShares,
          cardNumber: cryptr.encrypt(values.cardNumber),
          securityCode: cryptr.encrypt(values.securityCode),
          fullBigAnimal: fullBigAnimal,
          otherDonation: otherDonation,
          donation: totalCost,
          invoiceAmount: parseFloat(Number(invoiceAmount).toFixed(2)),
          isProcessingFeeAdded: values.isProcessingFeeAdded,
          paymentProcessingFee: paymentProcessingFee,
          donationAmount: donationAmount,
          firstName: values.firstName,
          lastName: values.lastName,
          country: values.country,
          region: values.region,
          address: values.address,
          address2: values.address2,
          city: values.city,
          postalCode: values.postalCode,
          email: values.email,
          type: values.type,
          donationType: 'general',
          programType: values.programType,
          beneficiaryName:
            qurbaniCustomValue && qurbaniCustomValue !== undefined
              ? qurbaniCustomValue
              : '',
          qurbaniShare1Name:
            qurbaniShare1Value && qurbaniShare1Value !== undefined
              ? qurbaniShare1Value
              : '',
          qurbaniShare2Name:
            qurbaniShare2Value && qurbaniShare2Value !== undefined
              ? qurbaniShare2Value
              : '',
          qurbaniShare3Name:
            qurbaniShare3Value && qurbaniShare3Value !== undefined
              ? qurbaniShare3Value
              : '',
          qurbaniShare4Name:
            qurbaniShare4Value && qurbaniShare4Value !== undefined
              ? qurbaniShare4Value
              : '',
          qurbaniShare5Name:
            qurbaniShare5Value && qurbaniShare5Value !== undefined
              ? qurbaniShare5Value
              : '',
          qurbaniShare6Name:
            qurbaniShare6Value && qurbaniShare6Value !== undefined
              ? qurbaniShare6Value
              : '',
          qurbaniShare7Name:
            qurbaniShare7Value && qurbaniShare7Value !== undefined
              ? qurbaniShare7Value
              : '',
          expirationMonth: values.expirationMonth,
          expirationYear: values.expirationYear,
          makeDonationAnonymous: values.makeDonationAnonymous,
          uid: signInData.uid,
          lastFour: '***' + lastFour,
          id: id,
          created: new Date().getTime(),
          paymentDate: new Date(
            todayyyyy + '-' + todaymm + '-' + todaydd
          ).getTime(),
          status: 'scheduled',
          isPaid: false,
          comment: values.comment,
        };

        console.log('data--->', data);
        // const getInvolvedDonate =
        //   "http://localhost:5000/dev-sadqajariya/us-central1/getInvolvedApi/donate";

        const getInvolvedDonate =
          'https://us-central1-dev-sadqajariya.cloudfunctions.net/getInvolvedApi/donate';
        const headers = {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'POST',
          'Access-Control-Max-Age': '0',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Authorization',
        };
        const donateResponce = await axios
          .post(getInvolvedDonate, data, {
            headers: headers,
          })
          .then(function (response) {
            // console.log("response--->", response);
            setShowLoader(false);
            if (response.data.ERROR) {
              setBtnDisabled(false);
              setShowMessageSuccess(false);
              setMessageError(response.data.ERROR.raw.message);
              setShowMessageError(true);
            } else if (response.data.data === 'Success') {
              history.push('/qurbani/thanks');
              setValues({
                qurbaniLocation: 'Pakistan',
                quantityOfShares: '',
                cardNumber: '',
                securityCode: '',
                donation: '',
                firstName: '',
                lastName: '',
                country: '',
                region: '',
                address: '',
                address2: '',
                city: '',
                postalCode: '',
                email: '',
                type: 'once',
                donationType: '',
                programType: 'sadaqah-udhiya-qurbani-obligation',
                expirationMonth: '',
                expirationYear: '',
                isProcessingFeeAdded: true,
                makeDonationAnonymous: false,
                uid: '',
                comment: '',
              });
              setShowMessageSuccess(true);
              setShowMessageError(false);
              setBtnDisabled(false);
              const totalCost = costPerQurbaniShare;
              calcFee(totalCost);
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    } catch (error) {
      console.log('error--->', error);
    }
  };

  return (
    <>
      <HeaderStyleTwo />

      <div className='page-wrapper'>
        {/* <Header /> */}
        {/* <CustomHeaderSUQ /> */}

        <section
          className='contact-page'
          style={{ borderTop: '1px solid #eae5e3', padding: '40px 0 110px' }}
        >
          <div className='container'>
            <div className='block-title-custom text-center'>
              <h4>
                {/* $99 Fulfills Your Religious Obligations  */}
                Opportunity to support the needy with the blessed qurbani meat.
              </h4>
              <div className='row'>
                <div className='col-xl-8 offset-xl-2'>
                  <p>
                    <b>
                      Sadqa-E-Jariya Welfare Foundation has arranged for our
                      Supporters to perform Qurbani/Udhiya and distribute meat
                      on your behalf to needy and less fortunate families in
                      diffrent cities of Pakistan and various part of the world.
                      A large animal, with seven shares will be sacrificed on
                      your behalf.
                      <br />
                      Rs 30k ($110)/Share, Rs 65k ($235)/Goat, Rs 210k
                      ($770)/Full Big Animal
                      <br />
                      Above based on bank transfer rate as it is a direct wire
                      transfer from SJWF USA bank to NGO SJWF bank in Pakistan
                      {/* <a target="_blank" href="/sadaqah-udhiya-qurbani-obligations"><b>details</b></a> */}
                    </b>
                  </p>
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='col-xl-8 offset-xl-2'>
                <div className='contact-form' style={{ padding: 20 }}>
                  <div className='row'>
                    <div className='col-xl-12'>
                      <TextField
                        label='Enter quantity of shares [1-6]'
                        className={classes.textField}
                        value={values.quantityOfShares}
                        onChange={handleQuantityOfSharesChange}
                        name='quantityOfShares'
                        // type="number"
                        required
                        InputProps={{
                          // startAdornment: (
                          //     <InputAdornment position="start">
                          //         <FormatListNumberedIcon />
                          //     </InputAdornment>
                          // ),

                          inputComponent: SharesFormatCustom as any,
                          // inputProps: { min: "1", max: "6", step: "1" }
                        }}
                        inputProps={{
                          maxLength: CHARACTER_LIMIT_QUANTITYOFSHARES,
                        }}
                        variant='outlined'
                        style={{ width: '100%' }}
                      />
                      {isShowQuantityOfSharesError === true ? (
                        <div style={{ paddingTop: 5 }}>
                          <Alert severity='error'>
                            Quantity of shares cannot be empty
                          </Alert>
                        </div>
                      ) : (
                        <div></div>
                      )}
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-xl-6'>
                      <FormControlLabel
                        style={{ marginTop: 10 }}
                        control={
                          <Checkbox
                            checked={fullBigAnimal}
                            onChange={handleFullBigAnimalChange}
                            name='fullBigAnimal'
                            color='primary'
                          />
                        }
                        label='Full Big Animal, 7 Shares'
                      />
                    </div>
                    <div className='col-xl-6'>
                      <FormControlLabel
                        style={{ marginTop: 10 }}
                        control={
                          <Checkbox
                            checked={otherDonation}
                            onChange={handleOtherDonationChange}
                            name='otherDonation'
                            color='primary'
                          />
                        }
                        label='Other Donation'
                      />
                    </div>
                  </div>
                  {otherDonation === true ? (
                    <>
                      <div className='row'>
                        <div className='col-xl-12'>
                          <TextField
                            label='Enter Other Amount'
                            className={classes.textField}
                            value={values.donation}
                            onChange={handleChangeDonation}
                            name='donation'
                            required
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position='start'>
                                  <MoneyIcon />
                                </InputAdornment>
                              ),
                              inputComponent: DonationFormatCustom as any,
                            }}
                            inputProps={{
                              maxLength: CHARACTER_LIMIT_DONATION,
                            }}
                            variant='outlined'
                            style={{ width: '100%' }}
                          />
                          {isShowDonationError === true ? (
                            <div style={{ paddingTop: 5 }}>
                              <Alert severity='error'>
                                Donation amount cannot be empty
                              </Alert>
                            </div>
                          ) : (
                            <div></div>
                          )}
                        </div>
                      </div>
                    </>
                  ) : (
                    <div> </div>
                  )}

                  {qurbaniShare1 === true ? (
                    <>
                      <div className='row'>
                        <div className='col-xl-12'>
                          <TextField
                            label='Beneficiary name for share 1'
                            className={classes.textField}
                            value={qurbaniShare1Value}
                            onChange={handleChangeQurbaniShare1Value}
                            name='qurbaniShare1Value'
                            required
                            variant='outlined'
                            style={{ width: '100%' }}
                            InputProps={
                              {
                                // startAdornment: (
                                //     <InputAdornment position="start">
                                //         <TextFieldsIcon />
                                //     </InputAdornment>
                                // ),
                              }
                            }
                          />
                          {qurbaniShare1ValueError === true ? (
                            <div style={{ paddingTop: 5 }}>
                              <Alert severity='error'>
                                Beneficiary name for share 1 cannot be empty
                              </Alert>
                            </div>
                          ) : (
                            <div></div>
                          )}
                        </div>
                      </div>
                    </>
                  ) : (
                    <div></div>
                  )}

                  {qurbaniShare2 === true ? (
                    <>
                      <div className='row'>
                        <div className='col-xl-6'>
                          <FormControlLabel
                            style={{ marginTop: 10 }}
                            control={
                              <Checkbox
                                checked={copyToAll}
                                onChange={handleCopyToAllChange}
                                name='copyToAll'
                                color='primary'
                              />
                            }
                            label='Copy to all'
                          />
                        </div>
                      </div>
                      <div className='row'>
                        <div className='col-xl-12'>
                          <TextField
                            label='Beneficiary name for share 2'
                            className={classes.textField}
                            value={qurbaniShare2Value}
                            onChange={handleChangeQurbaniShare2Value}
                            name='qurbaniShare2Value'
                            required
                            variant='outlined'
                            style={{ width: '100%' }}
                            InputProps={
                              {
                                // startAdornment: (
                                //     <InputAdornment position="start">
                                //         <TextFieldsIcon />
                                //     </InputAdornment>
                                // ),
                              }
                            }
                          />
                          {qurbaniShare2ValueError === true ? (
                            <div style={{ paddingTop: 5 }}>
                              <Alert severity='error'>
                                Beneficiary name for share 2 cannot be empty
                              </Alert>
                            </div>
                          ) : (
                            <div></div>
                          )}
                        </div>
                      </div>
                    </>
                  ) : (
                    <div></div>
                  )}
                  {qurbaniShare3 === true ? (
                    <div className='row'>
                      <div className='col-xl-12'>
                        <TextField
                          label='Beneficiary name for share 3'
                          className={classes.textField}
                          value={qurbaniShare3Value}
                          onChange={handleChangeQurbaniShare3Value}
                          name='qurbaniShare3Value'
                          required
                          variant='outlined'
                          style={{ width: '100%' }}
                          InputProps={
                            {
                              // startAdornment: (
                              //     <InputAdornment position="start">
                              //         <TextFieldsIcon />
                              //     </InputAdornment>
                              // ),
                            }
                          }
                        />
                        {qurbaniShare3ValueError === true ? (
                          <div style={{ paddingTop: 5 }}>
                            <Alert severity='error'>
                              Beneficiary name for share 3 cannot be empty
                            </Alert>
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>
                    </div>
                  ) : (
                    <div></div>
                  )}

                  {qurbaniShare4 === true ? (
                    <div className='row'>
                      <div className='col-xl-12'>
                        <TextField
                          label='Beneficiary name for share 4'
                          className={classes.textField}
                          value={qurbaniShare4Value}
                          onChange={handleChangeQurbaniShare4Value}
                          name='qurbaniShare4Value'
                          required
                          variant='outlined'
                          style={{ width: '100%' }}
                          InputProps={
                            {
                              // startAdornment: (
                              //     <InputAdornment position="start">
                              //         <TextFieldsIcon />
                              //     </InputAdornment>
                              // ),
                            }
                          }
                        />
                        {qurbaniShare4ValueError === true ? (
                          <div style={{ paddingTop: 5 }}>
                            <Alert severity='error'>
                              Beneficiary name for share 4 cannot be empty
                            </Alert>
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>
                    </div>
                  ) : (
                    <div></div>
                  )}

                  {qurbaniShare5 === true ? (
                    <div className='row'>
                      <div className='col-xl-12'>
                        <TextField
                          label='Beneficiary name for share 5'
                          className={classes.textField}
                          value={qurbaniShare5Value}
                          onChange={handleChangeQurbaniShare5Value}
                          name='qurbaniShare5Value'
                          required
                          variant='outlined'
                          style={{ width: '100%' }}
                          InputProps={
                            {
                              // startAdornment: (
                              //     <InputAdornment position="start">
                              //         <TextFieldsIcon />
                              //     </InputAdornment>
                              // ),
                            }
                          }
                        />
                        {qurbaniShare5ValueError === true ? (
                          <div style={{ paddingTop: 5 }}>
                            <Alert severity='error'>
                              Beneficiary name for share 5 cannot be empty
                            </Alert>
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>
                    </div>
                  ) : (
                    <div></div>
                  )}

                  {qurbaniShare6 === true ? (
                    <div className='row'>
                      <div className='col-xl-12'>
                        <TextField
                          label='Beneficiary name for share 6'
                          className={classes.textField}
                          value={qurbaniShare6Value}
                          onChange={handleChangeQurbaniShare6Value}
                          name='qurbaniShare6Value'
                          required
                          variant='outlined'
                          style={{ width: '100%' }}
                          InputProps={
                            {
                              // startAdornment: (
                              //     <InputAdornment position="start">
                              //         <TextFieldsIcon />
                              //     </InputAdornment>
                              // ),
                            }
                          }
                        />
                        {qurbaniShare6ValueError === true ? (
                          <div style={{ paddingTop: 5 }}>
                            <Alert severity='error'>
                              Beneficiary name for share 6 cannot be empty
                            </Alert>
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>
                    </div>
                  ) : (
                    <div></div>
                  )}

                  {qurbaniShare7 === true ? (
                    <div className='row'>
                      <div className='col-xl-12'>
                        <TextField
                          label='Beneficiary name for share 7'
                          className={classes.textField}
                          value={qurbaniShare7Value}
                          onChange={handleChangeQurbaniShare7Value}
                          name='qurbaniShare7Value'
                          required
                          variant='outlined'
                          style={{ width: '100%' }}
                          InputProps={
                            {
                              // startAdornment: (
                              //     <InputAdornment position="start">
                              //         <TextFieldsIcon />
                              //     </InputAdornment>
                              // ),
                            }
                          }
                        />
                        {qurbaniShare7ValueError === true ? (
                          <div style={{ paddingTop: 5 }}>
                            <Alert severity='error'>
                              Beneficiary name for share 7 cannot be empty
                            </Alert>
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>
                    </div>
                  ) : (
                    <div></div>
                  )}

                  <div className='row'>
                    <div className='col-xl-12'>
                      <span>
                        <b>Supporter's Information:</b>
                      </span>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-xl-6'>
                      <TextField
                        label='First Name'
                        className={classes.textField}
                        value={values.firstName}
                        onChange={handleChangeFirstName}
                        required
                        name='firstName'
                        InputProps={
                          {
                            // startAdornment: (
                            //     <InputAdornment position="start">
                            //         <TextFieldsIcon />
                            //     </InputAdornment>
                            // ),
                          }
                        }
                        inputProps={{
                          maxLength: CHARACTER_LIMIT_FIRST_NAME,
                        }}
                        variant='outlined'
                        style={{ width: '100%' }}
                      />
                      {isShowFirstNameError === true ? (
                        <div style={{ paddingTop: 5 }}>
                          <Alert severity='error'>
                            First Name cannot be empty
                          </Alert>
                        </div>
                      ) : (
                        <div></div>
                      )}
                    </div>
                    <div className='col-xl-6'>
                      <TextField
                        label='Last Name'
                        className={classes.textField}
                        value={values.lastName}
                        onChange={handleChangeLastName}
                        required
                        name='lastName'
                        InputProps={
                          {
                            // startAdornment: (
                            //     <InputAdornment position="start">
                            //         <TextFieldsIcon />
                            //     </InputAdornment>
                            // ),
                          }
                        }
                        inputProps={{
                          maxLength: CHARACTER_LIMIT_LAST_NAME,
                        }}
                        variant='outlined'
                        style={{ width: '100%' }}
                      />
                      {isShowLastNameError === true ? (
                        <div style={{ paddingTop: 5 }}>
                          <Alert severity='error'>
                            Last Name cannot be empty
                          </Alert>
                        </div>
                      ) : (
                        <div></div>
                      )}
                    </div>
                  </div>
                  {/* <div className="row">
                                        <div className="col-xl-12">
                                            <FormControlLabel
                                                style={{ marginTop: 10 }}
                                                control={
                                                    <Checkbox
                                                        checked={values.makeDonationAnonymous}
                                                        onChange={handleChange}
                                                        name="makeDonationAnonymous"
                                                        color="primary"
                                                    />
                                                }
                                                label="Make donation anonymous"
                                            />
                                        </div>
                                    </div> */}
                  <div className='row'>
                    <div className='col-xl-12'>
                      <FormControl
                        variant='outlined'
                        className={classes.formControl}
                        style={{ width: '100%' }}
                      >
                        <InputLabel id='Country'>Country</InputLabel>
                        <Select
                          labelId='Country'
                          id='selectCountry'
                          required
                          value={values?.country}
                          defaultValue={values?.country}
                          onChange={handleChangeCountry}
                          label='Country'
                          name='country'
                        >
                          {CountryRegionData.map((option, index) => (
                            <MenuItem key={option[0]} value={option[0]}>
                              {option[0]}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>

                      {isShowCountryError === true ? (
                        <div style={{ paddingTop: 5 }}>
                          <Alert severity='error'>
                            Country cannot be empty
                          </Alert>
                        </div>
                      ) : (
                        <div></div>
                      )}
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-xl-12'>
                      <TextField
                        label='Address'
                        className={classes.textField}
                        value={values.address}
                        onChange={handleChangeAddress}
                        name='address'
                        placeholder='Address line 1'
                        required
                        InputProps={
                          {
                            // startAdornment: (
                            //     <InputAdornment position="start">
                            //         <Streetview />
                            //     </InputAdornment>
                            // ),
                            // inputComponent: TextMaskCustom as any,
                          }
                        }
                        inputProps={{
                          maxLength: CHARACTER_LIMIT_EMAIL_NAME,
                        }}
                        variant='outlined'
                        style={{ width: '100%' }}
                      />
                      {isShowAddressError === true ? (
                        <div style={{ paddingTop: 5 }}>
                          <Alert severity='error'>
                            Address line 1 cannot be empty
                          </Alert>
                        </div>
                      ) : (
                        <div></div>
                      )}
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-xl-12'>
                      <TextField
                        label='Address2'
                        className={classes.textField}
                        value={values.address2}
                        onChange={handleChangeAddress2}
                        name='address2'
                        placeholder='Address line 2'
                        InputProps={
                          {
                            // startAdornment: (
                            //     <InputAdornment position="start">
                            //         <MyLocation />
                            //     </InputAdornment>
                            // ),
                            // inputComponent: TextMaskCustom as any,
                          }
                        }
                        inputProps={{
                          maxLength: CHARACTER_LIMIT_EMAIL_NAME,
                        }}
                        variant='outlined'
                        style={{ width: '100%' }}
                      />
                      {/* {isShowAddress2Error === true ? (
                        <div style={{ paddingTop: 5 }}>
                          <Alert severity="error">Address line 1 cannot be empty</Alert>
                        </div>
                      ) : (
                        <div></div>
                      )} */}
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-xl-12'>
                      <TextField
                        label='City'
                        className={classes.textField}
                        value={values.city}
                        required
                        onChange={handleChangeCity}
                        name='city'
                        placeholder='City'
                        InputProps={
                          {
                            // startAdornment: (
                            //     <InputAdornment position="start">
                            //         <LocationOn />
                            //     </InputAdornment>
                            // ),
                            // inputComponent: TextMaskCustom as any,
                          }
                        }
                        inputProps={{
                          maxLength: CHARACTER_LIMIT_EMAIL_NAME,
                        }}
                        variant='outlined'
                        style={{ width: '100%' }}
                      />
                      {isShowCityError === true ? (
                        <div style={{ paddingTop: 5 }}>
                          <Alert severity='error'>City cannot be empty</Alert>
                        </div>
                      ) : (
                        <div></div>
                      )}
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-xl-6'>
                      <FormControl
                        variant='outlined'
                        className={classes.formControl}
                        style={{ width: '100%' }}
                      >
                        <InputLabel id='Region'>State</InputLabel>
                        <Select
                          labelId='Region'
                          id='selectRegion'
                          value={values?.region}
                          required
                          onChange={handleChangeRegion}
                          label='Region'
                          name='Region'
                        >
                          {getRegions().map((option, index) => (
                            <MenuItem key={option} value={option}>
                              {option}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>

                      {isShowRegionError === true ? (
                        <div style={{ paddingTop: 5 }}>
                          <Alert severity='error'>State cannot be empty</Alert>
                        </div>
                      ) : (
                        <div></div>
                      )}
                    </div>
                    <div className='col-xl-6'>
                      <TextField
                        label='ZIP Code'
                        className={classes.textField}
                        value={values.postalCode}
                        required
                        onChange={handleChangePostalCode}
                        name='postalCode'
                        placeholder='ZIP code.'
                        InputProps={
                          {
                            // startAdornment: (
                            //     <InputAdornment position="start">
                            //         <EditLocationIcon />
                            //     </InputAdornment>
                            // ),
                            // inputComponent: TextMaskCustom as any,
                          }
                        }
                        inputProps={{
                          maxLength: CHARACTER_LIMIT_ZIP,
                        }}
                        variant='outlined'
                        style={{ width: '100%' }}
                      />
                      {isShowPostalCodeError === true ? (
                        <div style={{ paddingTop: 5 }}>
                          <Alert severity='error'>
                            ZIP code cannot be empty
                          </Alert>
                        </div>
                      ) : (
                        <div></div>
                      )}
                    </div>
                  </div>

                  <div className='row'>
                    <div className='col-xl-12'>
                      <TextField
                        label='Your Email'
                        className={classes.textField}
                        value={values.email}
                        onChange={handleChangeEmail}
                        name='email'
                        // required
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position='start'>
                              <AlternateEmailIcon />
                            </InputAdornment>
                          ),
                          // inputComponent: TextMaskCustom as any,
                        }}
                        inputProps={{
                          maxLength: CHARACTER_LIMIT_EMAIL_NAME,
                        }}
                        variant='outlined'
                        style={{ width: '100%' }}
                      />
                      {isShowEmailError === true ? (
                        <div style={{ paddingTop: 5 }}>
                          <Alert severity='error'>Email cannot be empty</Alert>
                        </div>
                      ) : (
                        <div></div>
                      )}
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-xl-12'>
                      <TextField
                        label='Credit or Debit Card Number'
                        className={classes.textField}
                        value={values.cardNumber}
                        onChange={handleChangeCardNumber}
                        name='cardNumber'
                        autoComplete='none'
                        required
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position='start'>
                              <PaymentIcon />
                            </InputAdornment>
                          ),
                          inputComponent: CardNumberFormatCustom as any,
                        }}
                        inputProps={{
                          maxLength: CHARACTER_LIMIT_CARD_NUMBER,
                        }}
                        variant='outlined'
                        style={{ width: '100%' }}
                      />
                      {isShowCardNumberError === true ? (
                        <div style={{ paddingTop: 5 }}>
                          <Alert severity='error'>
                            Card Number cannot be empty
                          </Alert>
                        </div>
                      ) : (
                        <div></div>
                      )}
                    </div>
                  </div>

                  <div className='row'>
                    <div className='col-xl-6'>
                      <FormControl
                        variant='outlined'
                        className={classes.formControl}
                        style={{ width: '100%' }}
                      >
                        <InputLabel id='demo-simple-select-outlined-label'>
                          Expiration Month
                        </InputLabel>
                        <Select
                          labelId='demo-simple-select-outlined-label'
                          id='demo-simple-select-outlined'
                          required
                          value={values.expirationMonth}
                          onChange={handleChangeExpirationMonth}
                          label='Expiration Month'
                          name='expirationMonth'
                        >
                          <MenuItem value=''>
                            <em>None</em>
                          </MenuItem>
                          <MenuItem value={'01'}>01 - January</MenuItem>
                          <MenuItem value={'02'}>02 - February</MenuItem>
                          <MenuItem value={'03'}>03 - March</MenuItem>
                          <MenuItem value={'04'}>04 - April</MenuItem>
                          <MenuItem value={'05'}>05 - May</MenuItem>
                          <MenuItem value={'06'}>06 - June</MenuItem>
                          <MenuItem value={'07'}>07 - July</MenuItem>
                          <MenuItem value={'08'}>08 - August</MenuItem>
                          <MenuItem value={'9'}>09 - September</MenuItem>
                          <MenuItem value={'10'}>10 - October</MenuItem>
                          <MenuItem value={'11'}>11 - November</MenuItem>
                          <MenuItem value={'12'}>12 - December</MenuItem>
                        </Select>
                      </FormControl>
                      {isShowExpirationMonthError === true ? (
                        <div style={{ paddingTop: 5 }}>
                          <Alert severity='error'>
                            Expiration Month cannot be empty
                          </Alert>
                        </div>
                      ) : (
                        <div></div>
                      )}
                    </div>
                    <div className='col-xl-6'>
                      <FormControl
                        variant='outlined'
                        className={classes.formControl}
                        style={{ width: '100%' }}
                      >
                        <InputLabel id='demo-simple-select-outlined-label'>
                          Expiration Year
                        </InputLabel>
                        <Select
                          labelId='demo-simple-select-outlined-label'
                          id='demo-simple-select-outlined'
                          required
                          value={values.expirationYear}
                          onChange={handleChangeExpirationYear}
                          label='Expiration Year'
                          name='expirationYear'
                        >
                          <MenuItem value=''>
                            <em>None</em>
                          </MenuItem>
                          <MenuItem value={'2021'}>2021</MenuItem>
                          <MenuItem value={'2022'}>2022</MenuItem>
                          <MenuItem value={'2023'}>2023</MenuItem>
                          <MenuItem value={'2024'}>2024</MenuItem>
                          <MenuItem value={'2025'}>2025</MenuItem>
                          <MenuItem value={'2026'}>2026</MenuItem>
                          <MenuItem value={'2027'}>2027</MenuItem>
                          <MenuItem value={'2028'}>2028</MenuItem>
                          <MenuItem value={'2029'}>2029</MenuItem>
                          <MenuItem value={'2030'}>2030</MenuItem>
                          <MenuItem value={'2031'}>2031</MenuItem>
                          <MenuItem value={'2032'}>2032</MenuItem>
                          <MenuItem value={'2033'}>2033</MenuItem>
                          <MenuItem value={'2034'}>2034</MenuItem>
                          <MenuItem value={'2035'}>2035</MenuItem>
                          <MenuItem value={'2036'}>2036</MenuItem>
                          <MenuItem value={'2037'}>2037</MenuItem>
                          <MenuItem value={'2038'}>2038</MenuItem>
                          <MenuItem value={'2039'}>2039</MenuItem>
                          <MenuItem value={'2040'}>2040</MenuItem>
                        </Select>
                      </FormControl>
                      {isShowExpirationYearError === true ? (
                        <div style={{ paddingTop: 5 }}>
                          <Alert severity='error'>
                            Expiration Year cannot be empty
                          </Alert>
                        </div>
                      ) : (
                        <div></div>
                      )}
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-xl-6'>
                      <TextField
                        label='Security Code Number'
                        className={classes.textField}
                        value={values.securityCode}
                        onChange={handleChangeSecurityCode}
                        name='securityCode'
                        autoComplete='none'
                        required
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position='start'>
                              <SecurityIcon />
                            </InputAdornment>
                          ),
                          inputComponent: SecurityCodeFormatCustom as any,
                        }}
                        variant='outlined'
                        style={{ width: '100%' }}
                      />
                      {isShowSecurityCodeError === true ? (
                        <div style={{ paddingTop: 5 }}>
                          <Alert severity='error'>
                            Security Code Number cannot be empty
                          </Alert>
                        </div>
                      ) : (
                        <div></div>
                      )}
                    </div>
                    <div className='col-xl-6'>
                      <span className='donationsprite donatesprite-creditcards'></span>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-xl-12'>
                      <TextField
                        id='outlined-multiline-static'
                        style={{ width: '100%', marginTop: 10 }}
                        label='Comment'
                        value={values.comment}
                        onChange={handleChangeComment}
                        name='comment'
                        multiline
                        rows={4}
                        variant='outlined'
                        inputProps={{
                          maxLength: CHARACTER_LIMIT_COMMENT,
                        }}
                      />
                    </div>
                  </div>

                  <div className='row'>
                    <div className='col-xl-12'>
                      <FormControlLabel
                        style={{ marginTop: 10 }}
                        control={
                          <Checkbox
                            checked={values.isProcessingFeeAdded}
                            onChange={handleIsProcessingFeeAddedChange}
                            name='isProcessingFeeAdded'
                            color='primary'
                          />
                        }
                        label='I’d like to cover the fees associated with my Qurbani/Udhiya/Sadaqah so more of my money goes directly to Qurbani/Udhiya/Sadaqah'
                      />
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-xl-12'>
                      {/* <p>*Note: Your card information is secured using SSL (Secure Sockets Layer), the leading security protocol on the Internet. Information is encrypted and exchanged with an https server.</p> */}
                      {showLoader === true ? (
                        <div>
                          <Alert style={{ marginTop: 20 }} severity='info'>
                            <b>
                              please wait for a while you transaction is under
                              progress
                            </b>
                          </Alert>
                        </div>
                      ) : (
                        <div></div>
                      )}
                      {showMessageSuccess === true ? (
                        <div>
                          <Alert style={{ marginTop: 20 }} severity='success'>
                            <b>
                              {' '}
                              Thank you so much for your Support, detailed
                              receipt has been emailed to you . you will receive
                              email shortly
                            </b>
                          </Alert>
                        </div>
                      ) : (
                        <div></div>
                      )}
                      {showMessageError === true ? (
                        <div>
                          <Alert style={{ marginTop: 20 }} severity='error'>
                            <b>{messageError}</b>
                          </Alert>
                        </div>
                      ) : (
                        <div></div>
                      )}
                      <button
                        type='submit'
                        disabled={btnDisabled}
                        className='theme-btn btn-style-one btn-donate-now-title'
                        style={{ width: '100%', marginTop: 20, height: 50 }}
                        onClick={() => {
                          if (
                            values.type === undefined ||
                            values.type === null ||
                            values.type === ''
                          ) {
                            setIsShowTypeError(true);
                          }

                          if (
                            (values.quantityOfShares !== undefined ||
                              values.quantityOfShares !== null ||
                              values.quantityOfShares !== '') &&
                            values.quantityOfShares === '1' &&
                            (qurbaniShare1Value === undefined ||
                              qurbaniShare1Value === null ||
                              qurbaniShare1Value === '')
                          ) {
                            // console.log("yes1");
                            setQurbaniShare1ValueError(true);
                          }

                          if (
                            (values.quantityOfShares !== undefined ||
                              values.quantityOfShares !== null ||
                              values.quantityOfShares !== '') &&
                            values.quantityOfShares === '2' &&
                            (qurbaniShare2Value === undefined ||
                              qurbaniShare2Value === null ||
                              qurbaniShare2Value === '')
                          ) {
                            // console.log("yes2");
                            // setQurbaniShare1ValueError(true);
                            setQurbaniShare2ValueError(true);
                          }
                          if (
                            (values.quantityOfShares !== undefined ||
                              values.quantityOfShares !== null ||
                              values.quantityOfShares !== '') &&
                            values.quantityOfShares === '3' &&
                            (qurbaniShare3Value === undefined ||
                              qurbaniShare3Value === null ||
                              qurbaniShare3Value === '')
                          ) {
                            // console.log("yes3");
                            // setQurbaniShare1ValueError(true);
                            // setQurbaniShare2ValueError(true);
                            setQurbaniShare3ValueError(true);
                          }
                          if (
                            (values.quantityOfShares !== undefined ||
                              values.quantityOfShares !== null ||
                              values.quantityOfShares !== '') &&
                            values.quantityOfShares === '4' &&
                            (qurbaniShare4Value === undefined ||
                              qurbaniShare4Value === null ||
                              qurbaniShare4Value === '')
                          ) {
                            console.log('yes4');
                            // setQurbaniShare1ValueError(true);
                            // setQurbaniShare2ValueError(true);
                            // setQurbaniShare3ValueError(true);
                            setQurbaniShare4ValueError(true);
                          }
                          if (
                            (values.quantityOfShares !== undefined ||
                              values.quantityOfShares !== null ||
                              values.quantityOfShares !== '') &&
                            values.quantityOfShares === '5' &&
                            (qurbaniShare5Value === undefined ||
                              qurbaniShare5Value === null ||
                              qurbaniShare5Value === '')
                          ) {
                            // console.log("yes5");
                            // setQurbaniShare1ValueError(true);
                            // setQurbaniShare2ValueError(true);
                            // setQurbaniShare3ValueError(true);
                            // setQurbaniShare4ValueError(true);
                            setQurbaniShare5ValueError(true);
                          }

                          if (
                            (values.quantityOfShares !== undefined ||
                              values.quantityOfShares !== null ||
                              values.quantityOfShares !== '') &&
                            values.quantityOfShares === '6' &&
                            (qurbaniShare6Value === undefined ||
                              qurbaniShare6Value === null ||
                              qurbaniShare6Value === '')
                          ) {
                            // console.log("yes6");
                            // setQurbaniShare1ValueError(true);
                            // setQurbaniShare2ValueError(true);
                            // setQurbaniShare3ValueError(true);
                            // setQurbaniShare4ValueError(true);
                            // setQurbaniShare5ValueError(true);
                            setQurbaniShare6ValueError(true);
                          }
                          if (
                            (values.quantityOfShares !== undefined ||
                              values.quantityOfShares !== null ||
                              values.quantityOfShares !== '') &&
                            values.quantityOfShares === '7' &&
                            (qurbaniShare7Value === undefined ||
                              qurbaniShare7Value === null ||
                              qurbaniShare7Value === '')
                          ) {
                            // console.log("yes7");
                            // setQurbaniShare1ValueError(true);
                            // setQurbaniShare2ValueError(true);
                            // setQurbaniShare3ValueError(true);
                            // setQurbaniShare4ValueError(true);
                            // setQurbaniShare5ValueError(true);
                            // setQurbaniShare6ValueError(true);
                            setQurbaniShare7ValueError(true);
                          }
                          if (
                            (fullBigAnimal !== undefined ||
                              fullBigAnimal !== null) &&
                            fullBigAnimal === true &&
                            (qurbaniShare7Value === undefined ||
                              qurbaniShare7Value === null ||
                              qurbaniShare7Value === '')
                          ) {
                            // console.log("Full Animal");
                            // setQurbaniShare1ValueError(true);
                            // setQurbaniShare2ValueError(true);
                            // setQurbaniShare3ValueError(true);
                            // setQurbaniShare4ValueError(true);
                            // setQurbaniShare5ValueError(true);
                            // setQurbaniShare6ValueError(true);
                            setQurbaniShare7ValueError(true);
                          }
                          if (
                            (fullBigAnimal !== undefined ||
                              fullBigAnimal !== null) &&
                            fullBigAnimal === true &&
                            (qurbaniShare6Value === undefined ||
                              qurbaniShare6Value === null ||
                              qurbaniShare6Value === '')
                          ) {
                            // console.log("Full Animal");
                            // setQurbaniShare1ValueError(true);
                            // setQurbaniShare2ValueError(true);
                            // setQurbaniShare3ValueError(true);
                            // setQurbaniShare4ValueError(true);
                            // setQurbaniShare5ValueError(true);
                            setQurbaniShare6ValueError(true);
                            // setQurbaniShare7ValueError(true);
                          }
                          if (
                            (fullBigAnimal !== undefined ||
                              fullBigAnimal !== null) &&
                            fullBigAnimal === true &&
                            (qurbaniShare5Value === undefined ||
                              qurbaniShare5Value === null ||
                              qurbaniShare5Value === '')
                          ) {
                            // console.log("Full Animal");
                            // setQurbaniShare1ValueError(true);
                            // setQurbaniShare2ValueError(true);
                            // setQurbaniShare3ValueError(true);
                            // setQurbaniShare4ValueError(true);
                            setQurbaniShare5ValueError(true);
                            // setQurbaniShare6ValueError(true);
                            // setQurbaniShare7ValueError(true);
                          }

                          if (
                            (fullBigAnimal !== undefined ||
                              fullBigAnimal !== null) &&
                            fullBigAnimal === true &&
                            (qurbaniShare4Value === undefined ||
                              qurbaniShare4Value === null ||
                              qurbaniShare4Value === '')
                          ) {
                            // console.log("Full Animal");
                            // setQurbaniShare1ValueError(true);
                            // setQurbaniShare2ValueError(true);
                            // setQurbaniShare3ValueError(true);
                            setQurbaniShare4ValueError(true);
                            // setQurbaniShare5ValueError(true);
                            // setQurbaniShare6ValueError(true);
                            // setQurbaniShare7ValueError(true);
                          }

                          if (
                            (fullBigAnimal !== undefined ||
                              fullBigAnimal !== null) &&
                            fullBigAnimal === true &&
                            (qurbaniShare3Value === undefined ||
                              qurbaniShare3Value === null ||
                              qurbaniShare3Value === '')
                          ) {
                            // console.log("Full Animal");
                            // setQurbaniShare1ValueError(true);
                            // setQurbaniShare2ValueError(true);
                            setQurbaniShare3ValueError(true);
                            // setQurbaniShare4ValueError(true);
                            // setQurbaniShare5ValueError(true);
                            // setQurbaniShare6ValueError(true);
                            // setQurbaniShare7ValueError(true);
                          }

                          if (
                            (fullBigAnimal !== undefined ||
                              fullBigAnimal !== null) &&
                            fullBigAnimal === true &&
                            (qurbaniShare2Value === undefined ||
                              qurbaniShare2Value === null ||
                              qurbaniShare2Value === '')
                          ) {
                            // console.log("Full Animal");
                            // setQurbaniShare1ValueError(true);
                            setQurbaniShare2ValueError(true);
                            // setQurbaniShare3ValueError(true);
                            // setQurbaniShare4ValueError(true);
                            // setQurbaniShare5ValueError(true);
                            // setQurbaniShare6ValueError(true);
                            // setQurbaniShare7ValueError(true);
                          }

                          if (
                            (fullBigAnimal !== undefined ||
                              fullBigAnimal !== null) &&
                            fullBigAnimal === true &&
                            (qurbaniShare1Value === undefined ||
                              qurbaniShare1Value === null ||
                              qurbaniShare1Value === '')
                          ) {
                            // console.log("Full Animal");
                            setQurbaniShare1ValueError(true);
                            // setQurbaniShare2ValueError(true);
                            // setQurbaniShare3ValueError(true);
                            // setQurbaniShare4ValueError(true);
                            // setQurbaniShare5ValueError(true);
                            // setQurbaniShare6ValueError(true);
                            // setQurbaniShare7ValueError(true);
                          }

                          if (
                            fullBigAnimal === false &&
                            otherDonation === false &&
                            (values.quantityOfShares === undefined ||
                              values.quantityOfShares === null ||
                              values.quantityOfShares === '')
                          ) {
                            setIsShowQuantityOfSharesError(true);
                          }
                          if (
                            fullBigAnimal === true ||
                            otherDonation === true ||
                            (values.quantityOfShares !== undefined &&
                              values.quantityOfShares !== null &&
                              values.quantityOfShares !== '')
                          ) {
                            setIsShowQuantityOfSharesError(false);
                          }
                          if (
                            otherDonation === true &&
                            (values.donation === undefined ||
                              values.donation === null ||
                              values.donation === '')
                          ) {
                            setIsShowDonationError(true);
                          }
                          if (
                            otherDonation === true &&
                            (qurbaniCustomValue === undefined ||
                              qurbaniCustomValue === null ||
                              qurbaniCustomValue === '')
                          ) {
                            setQurbaniCustomValueError(true);
                          }

                          // if (
                          //     otherDonation === true &&
                          //     (values.donation !== undefined  ||
                          //     values.donation !== null ||
                          //     values.donation !== "")
                          // ) {
                          //     setIsShowDonationError(false);
                          // }
                          // if (
                          //     otherDonation === true &&
                          //     (qurbaniCustomValue !== undefined  ||
                          //         qurbaniCustomValue !== null ||
                          //         qurbaniCustomValue !== "")
                          // ) {
                          //     setQurbaniCustomValueError(false);
                          // }

                          if (
                            values.firstName === undefined ||
                            values.firstName === null ||
                            values.firstName === ''
                          ) {
                            setIsShowFirstNameError(true);
                          }
                          if (
                            values.lastName === undefined ||
                            values.lastName === null ||
                            values.lastName === ''
                          ) {
                            setIsShowLastNameError(true);
                          }
                          if (
                            values.country === undefined ||
                            values.country === null ||
                            values.country === ''
                          ) {
                            setIsShowCountryError(true);
                          }
                          if (
                            values.city === undefined ||
                            values.city === null ||
                            values.city === ''
                          ) {
                            setIsShowCityError(true);
                          }
                          if (
                            values.address === undefined ||
                            values.address === null ||
                            values.address === ''
                          ) {
                            setIsShowAddressError(true);
                          }
                          if (
                            values.postalCode === undefined ||
                            values.postalCode === null ||
                            values.postalCode === ''
                          ) {
                            setIsShowPostalCodeError(true);
                          }
                          if (
                            values.region === undefined ||
                            values.region === null ||
                            values.region === ''
                          ) {
                            setIsShowRegionError(true);
                          }
                          // if (
                          //     values.email === undefined ||
                          //     values.email === null ||
                          //     values.email === ""
                          // ) {
                          //     setIsShowEmailError(true);
                          // }

                          if (
                            values.cardNumber === undefined ||
                            values.cardNumber === null ||
                            values.cardNumber === ''
                          ) {
                            setIsShowCardNumberError(true);
                          }
                          if (
                            values.expirationMonth === undefined ||
                            values.expirationMonth === null ||
                            values.expirationMonth === ''
                          ) {
                            setIsShowExpirationMonthError(true);
                          }
                          if (
                            values.programType === undefined ||
                            values.programType === null ||
                            values.programType === ''
                          ) {
                            setIsShowProgramTypeError(true);
                          }
                          if (
                            values.expirationYear === undefined ||
                            values.expirationYear === null ||
                            values.expirationYear === ''
                          ) {
                            setIsShowExpirationYearError(true);
                          }
                          if (
                            values.securityCode === undefined ||
                            values.securityCode === null ||
                            values.securityCode === ''
                          ) {
                            setIsShowSecurityCodeError(true);
                          }
                          if (
                            (values.quantityOfShares !== undefined &&
                              values.quantityOfShares !== null &&
                              values.quantityOfShares !== '' &&
                              values.quantityOfShares === '1' &&
                              qurbaniShare1Value !== undefined &&
                              qurbaniShare1Value !== null &&
                              qurbaniShare1Value !== '' &&
                              values.type !== undefined &&
                              values.type !== null &&
                              values.type !== '' &&
                              values.programType !== undefined &&
                              values.programType !== null &&
                              values.programType !== '' &&
                              values.firstName !== undefined &&
                              values.firstName !== null &&
                              values.firstName !== '' &&
                              values.lastName !== undefined &&
                              values.lastName !== null &&
                              values.lastName !== '' &&
                              values.country !== undefined &&
                              values.country !== null &&
                              values.country !== '' &&
                              values.city !== undefined &&
                              values.city !== null &&
                              values.city !== '' &&
                              values.address !== undefined &&
                              values.address !== null &&
                              values.address !== '' &&
                              values.postalCode !== undefined &&
                              values.postalCode !== null &&
                              values.postalCode !== '' &&
                              values.region !== undefined &&
                              values.region !== null &&
                              values.region !== '' &&
                              // values.email !== undefined &&
                              // values.email !== null &&
                              // values.email !== "" &&
                              values.cardNumber !== undefined &&
                              values.cardNumber !== null &&
                              values.cardNumber !== '' &&
                              values.expirationMonth !== undefined &&
                              values.expirationMonth !== null &&
                              values.expirationMonth !== '' &&
                              values.expirationYear !== undefined &&
                              values.expirationYear !== null &&
                              values.expirationYear !== '' &&
                              values.securityCode !== undefined &&
                              values.securityCode !== null &&
                              values.securityCode !== '') ||
                            (values.quantityOfShares !== undefined &&
                              values.quantityOfShares !== null &&
                              values.quantityOfShares !== '' &&
                              values.quantityOfShares === '2' &&
                              qurbaniShare1Value !== undefined &&
                              qurbaniShare1Value !== null &&
                              qurbaniShare1Value !== '' &&
                              qurbaniShare2Value !== undefined &&
                              qurbaniShare2Value !== null &&
                              qurbaniShare2Value !== '' &&
                              values.type !== undefined &&
                              values.type !== null &&
                              values.type !== '' &&
                              values.programType !== undefined &&
                              values.programType !== null &&
                              values.programType !== '' &&
                              values.firstName !== undefined &&
                              values.firstName !== null &&
                              values.firstName !== '' &&
                              values.lastName !== undefined &&
                              values.lastName !== null &&
                              values.lastName !== '' &&
                              values.country !== undefined &&
                              values.country !== null &&
                              values.country !== '' &&
                              values.city !== undefined &&
                              values.city !== null &&
                              values.city !== '' &&
                              values.address !== undefined &&
                              values.address !== null &&
                              values.address !== '' &&
                              values.postalCode !== undefined &&
                              values.postalCode !== null &&
                              values.postalCode !== '' &&
                              values.region !== undefined &&
                              values.region !== null &&
                              values.region !== '' &&
                              // values.email !== undefined &&
                              // values.email !== null &&
                              // values.email !== "" &&
                              values.cardNumber !== undefined &&
                              values.cardNumber !== null &&
                              values.cardNumber !== '' &&
                              values.expirationMonth !== undefined &&
                              values.expirationMonth !== null &&
                              values.expirationMonth !== '' &&
                              values.expirationYear !== undefined &&
                              values.expirationYear !== null &&
                              values.expirationYear !== '' &&
                              values.securityCode !== undefined &&
                              values.securityCode !== null &&
                              values.securityCode !== '') ||
                            (values.quantityOfShares !== undefined &&
                              values.quantityOfShares !== null &&
                              values.quantityOfShares !== '' &&
                              values.quantityOfShares === '3' &&
                              qurbaniShare1Value !== undefined &&
                              qurbaniShare1Value !== null &&
                              qurbaniShare1Value !== '' &&
                              qurbaniShare2Value !== undefined &&
                              qurbaniShare2Value !== null &&
                              qurbaniShare2Value !== '' &&
                              qurbaniShare3Value !== undefined &&
                              qurbaniShare3Value !== null &&
                              qurbaniShare3Value !== '' &&
                              values.type !== undefined &&
                              values.type !== null &&
                              values.type !== '' &&
                              values.programType !== undefined &&
                              values.programType !== null &&
                              values.programType !== '' &&
                              values.firstName !== undefined &&
                              values.firstName !== null &&
                              values.firstName !== '' &&
                              values.lastName !== undefined &&
                              values.lastName !== null &&
                              values.lastName !== '' &&
                              values.country !== undefined &&
                              values.country !== null &&
                              values.country !== '' &&
                              values.city !== undefined &&
                              values.city !== null &&
                              values.city !== '' &&
                              values.address !== undefined &&
                              values.address !== null &&
                              values.address !== '' &&
                              values.postalCode !== undefined &&
                              values.postalCode !== null &&
                              values.postalCode !== '' &&
                              values.region !== undefined &&
                              values.region !== null &&
                              values.region !== '' &&
                              // values.email !== undefined &&
                              // values.email !== null &&
                              // values.email !== "" &&
                              values.cardNumber !== undefined &&
                              values.cardNumber !== null &&
                              values.cardNumber !== '' &&
                              values.expirationMonth !== undefined &&
                              values.expirationMonth !== null &&
                              values.expirationMonth !== '' &&
                              values.expirationYear !== undefined &&
                              values.expirationYear !== null &&
                              values.expirationYear !== '' &&
                              values.securityCode !== undefined &&
                              values.securityCode !== null &&
                              values.securityCode !== '') ||
                            (values.quantityOfShares !== undefined &&
                              values.quantityOfShares !== null &&
                              values.quantityOfShares !== '' &&
                              values.quantityOfShares === '4' &&
                              qurbaniShare1Value !== undefined &&
                              qurbaniShare1Value !== null &&
                              qurbaniShare1Value !== '' &&
                              qurbaniShare2Value !== undefined &&
                              qurbaniShare2Value !== null &&
                              qurbaniShare2Value !== '' &&
                              qurbaniShare3Value !== undefined &&
                              qurbaniShare3Value !== null &&
                              qurbaniShare3Value !== '' &&
                              qurbaniShare4Value !== undefined &&
                              qurbaniShare4Value !== null &&
                              qurbaniShare4Value !== '' &&
                              values.type !== undefined &&
                              values.type !== null &&
                              values.type !== '' &&
                              values.programType !== undefined &&
                              values.programType !== null &&
                              values.programType !== '' &&
                              values.firstName !== undefined &&
                              values.firstName !== null &&
                              values.firstName !== '' &&
                              values.lastName !== undefined &&
                              values.lastName !== null &&
                              values.lastName !== '' &&
                              values.country !== undefined &&
                              values.country !== null &&
                              values.country !== '' &&
                              values.city !== undefined &&
                              values.city !== null &&
                              values.city !== '' &&
                              values.address !== undefined &&
                              values.address !== null &&
                              values.address !== '' &&
                              values.postalCode !== undefined &&
                              values.postalCode !== null &&
                              values.postalCode !== '' &&
                              values.region !== undefined &&
                              values.region !== null &&
                              values.region !== '' &&
                              // values.email !== undefined &&
                              // values.email !== null &&
                              // values.email !== "" &&
                              values.cardNumber !== undefined &&
                              values.cardNumber !== null &&
                              values.cardNumber !== '' &&
                              values.expirationMonth !== undefined &&
                              values.expirationMonth !== null &&
                              values.expirationMonth !== '' &&
                              values.expirationYear !== undefined &&
                              values.expirationYear !== null &&
                              values.expirationYear !== '' &&
                              values.securityCode !== undefined &&
                              values.securityCode !== null &&
                              values.securityCode !== '') ||
                            (values.quantityOfShares !== undefined &&
                              values.quantityOfShares !== null &&
                              values.quantityOfShares !== '' &&
                              values.quantityOfShares === '5' &&
                              qurbaniShare1Value !== undefined &&
                              qurbaniShare1Value !== null &&
                              qurbaniShare1Value !== '' &&
                              qurbaniShare2Value !== undefined &&
                              qurbaniShare2Value !== null &&
                              qurbaniShare2Value !== '' &&
                              qurbaniShare3Value !== undefined &&
                              qurbaniShare3Value !== null &&
                              qurbaniShare3Value !== '' &&
                              qurbaniShare4Value !== undefined &&
                              qurbaniShare4Value !== null &&
                              qurbaniShare4Value !== '' &&
                              qurbaniShare5Value !== undefined &&
                              qurbaniShare5Value !== null &&
                              qurbaniShare5Value !== '' &&
                              values.type !== undefined &&
                              values.type !== null &&
                              values.type !== '' &&
                              values.programType !== undefined &&
                              values.programType !== null &&
                              values.programType !== '' &&
                              values.firstName !== undefined &&
                              values.firstName !== null &&
                              values.firstName !== '' &&
                              values.lastName !== undefined &&
                              values.lastName !== null &&
                              values.lastName !== '' &&
                              values.country !== undefined &&
                              values.country !== null &&
                              values.country !== '' &&
                              values.city !== undefined &&
                              values.city !== null &&
                              values.city !== '' &&
                              values.address !== undefined &&
                              values.address !== null &&
                              values.address !== '' &&
                              values.postalCode !== undefined &&
                              values.postalCode !== null &&
                              values.postalCode !== '' &&
                              values.region !== undefined &&
                              values.region !== null &&
                              values.region !== '' &&
                              // values.email !== undefined &&
                              // values.email !== null &&
                              // values.email !== "" &&
                              values.cardNumber !== undefined &&
                              values.cardNumber !== null &&
                              values.cardNumber !== '' &&
                              values.expirationMonth !== undefined &&
                              values.expirationMonth !== null &&
                              values.expirationMonth !== '' &&
                              values.expirationYear !== undefined &&
                              values.expirationYear !== null &&
                              values.expirationYear !== '' &&
                              values.securityCode !== undefined &&
                              values.securityCode !== null &&
                              values.securityCode !== '') ||
                            (values.quantityOfShares !== undefined &&
                              values.quantityOfShares !== null &&
                              values.quantityOfShares !== '' &&
                              values.quantityOfShares === '6' &&
                              qurbaniShare1Value !== undefined &&
                              qurbaniShare1Value !== null &&
                              qurbaniShare1Value !== '' &&
                              qurbaniShare2Value !== undefined &&
                              qurbaniShare2Value !== null &&
                              qurbaniShare2Value !== '' &&
                              qurbaniShare3Value !== undefined &&
                              qurbaniShare3Value !== null &&
                              qurbaniShare3Value !== '' &&
                              qurbaniShare4Value !== undefined &&
                              qurbaniShare4Value !== null &&
                              qurbaniShare4Value !== '' &&
                              qurbaniShare5Value !== undefined &&
                              qurbaniShare5Value !== null &&
                              qurbaniShare5Value !== '' &&
                              qurbaniShare6Value !== undefined &&
                              qurbaniShare6Value !== null &&
                              qurbaniShare6Value !== '' &&
                              values.type !== undefined &&
                              values.type !== null &&
                              values.type !== '' &&
                              values.programType !== undefined &&
                              values.programType !== null &&
                              values.programType !== '' &&
                              values.firstName !== undefined &&
                              values.firstName !== null &&
                              values.firstName !== '' &&
                              values.lastName !== undefined &&
                              values.lastName !== null &&
                              values.lastName !== '' &&
                              values.country !== undefined &&
                              values.country !== null &&
                              values.country !== '' &&
                              values.city !== undefined &&
                              values.city !== null &&
                              values.city !== '' &&
                              values.address !== undefined &&
                              values.address !== null &&
                              values.address !== '' &&
                              values.postalCode !== undefined &&
                              values.postalCode !== null &&
                              values.postalCode !== '' &&
                              values.region !== undefined &&
                              values.region !== null &&
                              values.region !== '' &&
                              // values.email !== undefined &&
                              // values.email !== null &&
                              // values.email !== "" &&
                              values.cardNumber !== undefined &&
                              values.cardNumber !== null &&
                              values.cardNumber !== '' &&
                              values.expirationMonth !== undefined &&
                              values.expirationMonth !== null &&
                              values.expirationMonth !== '' &&
                              values.expirationYear !== undefined &&
                              values.expirationYear !== null &&
                              values.expirationYear !== '' &&
                              values.securityCode !== undefined &&
                              values.securityCode !== null &&
                              values.securityCode !== '') ||
                            (values.quantityOfShares !== undefined &&
                              values.quantityOfShares !== null &&
                              values.quantityOfShares !== '' &&
                              values.quantityOfShares === '7' &&
                              qurbaniShare1Value !== undefined &&
                              qurbaniShare1Value !== null &&
                              qurbaniShare1Value !== '' &&
                              qurbaniShare2Value !== undefined &&
                              qurbaniShare2Value !== null &&
                              qurbaniShare2Value !== '' &&
                              qurbaniShare3Value !== undefined &&
                              qurbaniShare3Value !== null &&
                              qurbaniShare3Value !== '' &&
                              qurbaniShare4Value !== undefined &&
                              qurbaniShare4Value !== null &&
                              qurbaniShare4Value !== '' &&
                              qurbaniShare5Value !== undefined &&
                              qurbaniShare5Value !== null &&
                              qurbaniShare5Value !== '' &&
                              qurbaniShare6Value !== undefined &&
                              qurbaniShare6Value !== null &&
                              qurbaniShare6Value !== '' &&
                              qurbaniShare7Value !== undefined &&
                              qurbaniShare7Value !== null &&
                              qurbaniShare7Value !== '' &&
                              values.type !== undefined &&
                              values.type !== null &&
                              values.type !== '' &&
                              values.programType !== undefined &&
                              values.programType !== null &&
                              values.programType !== '' &&
                              values.firstName !== undefined &&
                              values.firstName !== null &&
                              values.firstName !== '' &&
                              values.lastName !== undefined &&
                              values.lastName !== null &&
                              values.lastName !== '' &&
                              values.country !== undefined &&
                              values.country !== null &&
                              values.country !== '' &&
                              values.city !== undefined &&
                              values.city !== null &&
                              values.city !== '' &&
                              values.address !== undefined &&
                              values.address !== null &&
                              values.address !== '' &&
                              values.postalCode !== undefined &&
                              values.postalCode !== null &&
                              values.postalCode !== '' &&
                              values.region !== undefined &&
                              values.region !== null &&
                              values.region !== '' &&
                              // values.email !== undefined &&
                              // values.email !== null &&
                              // values.email !== "" &&
                              values.cardNumber !== undefined &&
                              values.cardNumber !== null &&
                              values.cardNumber !== '' &&
                              values.expirationMonth !== undefined &&
                              values.expirationMonth !== null &&
                              values.expirationMonth !== '' &&
                              values.expirationYear !== undefined &&
                              values.expirationYear !== null &&
                              values.expirationYear !== '' &&
                              values.securityCode !== undefined &&
                              values.securityCode !== null &&
                              values.securityCode !== '') ||
                            (fullBigAnimal !== undefined &&
                              fullBigAnimal !== null &&
                              fullBigAnimal === true &&
                              qurbaniShare1Value !== undefined &&
                              qurbaniShare1Value !== null &&
                              qurbaniShare1Value !== '' &&
                              qurbaniShare2Value !== undefined &&
                              qurbaniShare2Value !== null &&
                              qurbaniShare2Value !== '' &&
                              qurbaniShare3Value !== undefined &&
                              qurbaniShare3Value !== null &&
                              qurbaniShare3Value !== '' &&
                              qurbaniShare4Value !== undefined &&
                              qurbaniShare4Value !== null &&
                              qurbaniShare4Value !== '' &&
                              qurbaniShare5Value !== undefined &&
                              qurbaniShare5Value !== null &&
                              qurbaniShare5Value !== '' &&
                              qurbaniShare6Value !== undefined &&
                              qurbaniShare6Value !== null &&
                              qurbaniShare6Value !== '' &&
                              qurbaniShare7Value !== undefined &&
                              qurbaniShare7Value !== null &&
                              qurbaniShare7Value !== '' &&
                              values.type !== undefined &&
                              values.type !== null &&
                              values.type !== '' &&
                              values.programType !== undefined &&
                              values.programType !== null &&
                              values.programType !== '' &&
                              values.firstName !== undefined &&
                              values.firstName !== null &&
                              values.firstName !== '' &&
                              values.lastName !== undefined &&
                              values.lastName !== null &&
                              values.lastName !== '' &&
                              values.country !== undefined &&
                              values.country !== null &&
                              values.country !== '' &&
                              values.city !== undefined &&
                              values.city !== null &&
                              values.city !== '' &&
                              values.address !== undefined &&
                              values.address !== null &&
                              values.address !== '' &&
                              values.postalCode !== undefined &&
                              values.postalCode !== null &&
                              values.postalCode !== '' &&
                              values.region !== undefined &&
                              values.region !== null &&
                              values.region !== '' &&
                              // values.email !== undefined &&
                              // values.email !== null &&
                              // values.email !== "" &&
                              values.cardNumber !== undefined &&
                              values.cardNumber !== null &&
                              values.cardNumber !== '' &&
                              values.expirationMonth !== undefined &&
                              values.expirationMonth !== null &&
                              values.expirationMonth !== '' &&
                              values.expirationYear !== undefined &&
                              values.expirationYear !== null &&
                              values.expirationYear !== '' &&
                              values.securityCode !== undefined &&
                              values.securityCode !== null &&
                              values.securityCode !== '') ||
                            (otherDonation !== undefined &&
                              otherDonation !== null &&
                              otherDonation === true &&
                              values.donation !== undefined &&
                              values.donation !== null &&
                              values.donation !== '' &&
                              values.type !== undefined &&
                              values.type !== null &&
                              values.type !== '' &&
                              values.programType !== undefined &&
                              values.programType !== null &&
                              values.programType !== '' &&
                              values.firstName !== undefined &&
                              values.firstName !== null &&
                              values.firstName !== '' &&
                              values.lastName !== undefined &&
                              values.lastName !== null &&
                              values.lastName !== '' &&
                              values.country !== undefined &&
                              values.country !== null &&
                              values.country !== '' &&
                              values.city !== undefined &&
                              values.city !== null &&
                              values.city !== '' &&
                              values.address !== undefined &&
                              values.address !== null &&
                              values.address !== '' &&
                              values.postalCode !== undefined &&
                              values.postalCode !== null &&
                              values.postalCode !== '' &&
                              values.region !== undefined &&
                              values.region !== null &&
                              values.region !== '' &&
                              // values.email !== undefined &&
                              // values.email !== null &&
                              // values.email !== "" &&
                              values.cardNumber !== undefined &&
                              values.cardNumber !== null &&
                              values.cardNumber !== '' &&
                              values.expirationMonth !== undefined &&
                              values.expirationMonth !== null &&
                              values.expirationMonth !== '' &&
                              values.expirationYear !== undefined &&
                              values.expirationYear !== null &&
                              values.expirationYear !== '' &&
                              values.securityCode !== undefined &&
                              values.securityCode !== null &&
                              values.securityCode !== '')
                          ) {
                            setBtnDisabled(true);
                            setShowMessageSuccess(false);
                            setShowMessageError(false);
                            setShowLoader(true);
                            donateNow();
                          }
                        }}
                      >
                        Submit (${invoiceAmount})
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <CustomFooter /> */}
      </div>
      <ScrollToTop />
      <Footer />
    </>
  );
};

export default DonateToQurbaniUdhiyaSadaqahObligations;
